import React from "react";
import CrmLeadsWorkspace from "../Crm/CrmLeadsWorkspace";

/** Legacy page shell — shared workspace with CRM Hub leads tab. */
export default function AISalesLeadsPageV2() {
  return <CrmLeadsWorkspace />;
}
